import React, { useEffect, useState } from "react";

const CountdownTimer = ({ targetDate }) => {
  const calculateTimeLeft = () => {
    const difference = new Date(targetDate) - new Date();
    if (difference > 0) {
      return {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }
    return null;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer); // Cleanup on unmount
    // eslint-disable-next-line
  }, [targetDate]);

  if (!timeLeft) {
    return <span>Time's up!</span>;
  }

  return (
    <div>
      <div className="w-full pt-5 flex gap-10">
        <div className="">
          <h1 className="text-4xl">
            {timeLeft?.days?.toString()?.padStart(2, "0")}
          </h1>
          <h4 className="text-xl text-gray-500">Days</h4>
        </div>
        <div className="">
          <h1 className="text-4xl">
            {timeLeft?.hours?.toString()?.padStart(2, "0")}
          </h1>
          <h4 className="text-xl text-gray-500">Hour</h4>
        </div>
        <div className="">
          <h1 className="text-4xl">
            {timeLeft?.minutes?.toString()?.padStart(2, "0")}
          </h1>
          <h4 className="text-xl text-gray-500">Mint</h4>
        </div>
        <div className="">
          <h1 className="text-4xl">
            {timeLeft?.seconds?.toString()?.padStart(2, "0")}
          </h1>
          <h4 className="text-xl text-gray-500">Secs</h4>
        </div>
      </div>
    </div>
  );
};

export default CountdownTimer;
